import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const useCostSavingsStore = createStore((set) => ({
  yearFilter: { value: new Date().getFullYear(), label: new Date().getFullYear() },
  includeUnverifiedSavings: false,
  chartType: 'costSavings',
  sorting: { ...initialSorting },
  actions: {
    setYearFilter: (yearFilter) => set({ yearFilter }),
    setIncludeUnverifiedSavings: (includeUnverifiedSavings) => set({ includeUnverifiedSavings }),
    setChartType: (chartType) => set({ chartType }),
    setCostSavingsSorting: (sorting) => set({ sorting }),
  },
}));

export const selectCostSavingsYearFilter = () => useCostSavingsStore((state) => state.yearFilter);
export const selectCostSavingsIncludeUnverifiedSavings = () =>
  useCostSavingsStore((state) => state.includeUnverifiedSavings);
export const selectChartType = () => useCostSavingsStore((state) => state.chartType);
export const selectCostSavingsSorting = () => useCostSavingsStore((state) => state.sorting);

export const useCostSavingsActions = () => useCostSavingsStore((state) => state.actions);
